// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1fW8T{display:-ms-flexbox;display:flex;height:226px;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.modal__body{height:auto!important;max-height:90vh}", ""]);
// Exports
exports.locals = {
	"offline__container": "_1fW8T"
};
module.exports = exports;
